// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultErrorBoundary_root__1cklX","heading":"DefaultErrorBoundary_heading__3YQnH","sub_heading":"DefaultErrorBoundary_sub_heading__1vZz2"};